var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "codes"
  }, [_c('div', {
    staticClass: "d-flex align-center pt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-arrow-left")])], 1)], 1), _c('div', {
    staticClass: "page-title mono pl-3"
  }, [_vm._v(_vm._s(_vm.$t('codes_all_qrs')))]), _c('codes-csv', {
    ref: "csv-add-codes",
    staticClass: "ml-4",
    on: {
      "codes-activated": _vm.resetBulkSelection
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center pt-5 mx-8"
  }, [_c('codes-search', {
    ref: "codeSearch",
    staticClass: "flex-grow-1 mr-4",
    attrs: {
      "campaign": _vm.selectedCampaign.id
    }
  }), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "download-btn",
          attrs: {
            "color": "primary",
            "raised": "",
            "loading": _vm.downloadingCsv,
            "disabled": !_vm.csvCount
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t('download'))), _c('v-icon', {
          staticClass: "download-btn-arrow"
        }, [_vm._v("mdi-chevron-down")])], 1)];
      }
    }])
  }, [_c('v-list', [_c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.$refs.qrDownload.open();
      }
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('download_qr_code_images')))])], 1), _vm.csvCount <= 1000 ? _c('v-list-item', {
    on: {
      "click": _vm.downloadCodesCsv
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('download_urls_in_csv')))])], 1) : _vm._e()], 1)], 1), _c('download', {
    ref: "qrDownload",
    attrs: {
      "hide-activator": true,
      "mode": "codes",
      "count": _vm.selectAllEnabled ? _vm.filteredCodeCount : _vm.selectedCodesIndexes.length,
      "select-all": _vm.selectAllEnabled,
      "codes": _vm.selectedCodes,
      "campaign": _vm.selectedCampaign.id,
      "product": _vm.selectedCodes.length === 1 ? _vm.selectedCodes[0].product.id : undefined,
      "enable-qr-text-settings": _vm.selectedCodes.length === 1 ? true : false
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.filteredProductCount,
      expression: "filteredProductCount"
    }],
    staticClass: "d-flex align-center justify-space-between search-settings mx-8"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "value": _vm.selectAllEnabled
    },
    on: {
      "click": function ($event) {
        return _vm.toggleSelectAll();
      }
    }
  }), _c('div', {
    staticClass: "search-label mr-4"
  }, [_vm._v(_vm._s(_vm.$t('codes_selected')) + ": " + _vm._s(_vm.selectAllEnabled ? _vm.filteredCodeCount : _vm.selectedCodesIndexes.length))]), _vm.activeCodesFilters.length ? _c('div', {
    staticClass: "search-label mr-4"
  }, [_vm._v(_vm._s(_vm.$t('codes_results')) + ": " + _vm._s(_vm.filteredCodeCount))]) : _vm._e(), _c('div', {
    staticClass: "search-label mr-2"
  }, [_vm._v(_vm._s(_vm.$t('filters')) + ":")]), !_vm.activeCodesFilters.length ? _c('div', {
    staticClass: "search-label"
  }, [_vm._v(_vm._s(_vm.$t('none')))]) : _vm._e(), _vm._l(_vm.activeCodesFilters, function (filter, index) {
    return _c('v-chip', {
      key: `active-filters-${index}`,
      staticClass: "ml-2",
      attrs: {
        "close": "",
        "color": "#f1f1f1",
        "text-color": "#0789b2"
      },
      on: {
        "click": function ($event) {
          return _vm.editActiveFilter(filter);
        },
        "click:close": function ($event) {
          return _vm.removeFilter(filter);
        }
      }
    }, [_vm._v(" " + _vm._s(filter.name) + ": " + _vm._s(filter.value) + " ")]);
  })], 2), _c('v-spacer'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codesLoaded,
      expression: "codesLoaded"
    }],
    staticClass: "search-label mr-7 flex-shrink-0 mono"
  }, [_vm._v(_vm._s(_vm.$t('total')) + ": " + _vm._s(_vm.filteredCodeCount))]), _c('button', {
    staticClass: "d-flex show-url-btn",
    on: {
      "click": function ($event) {
        _vm.showUrl = !_vm.showUrl;
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.visibilityImgUrl
    }
  }), _vm.showUrl ? _c('span', [_vm._v(_vm._s(_vm.$t('hide_url_prefixes')))]) : _vm._e(), !_vm.showUrl ? _c('span', [_vm._v(_vm._s(_vm.$t('show_url_prefixes')))]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "code-list-ctn mx-8"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.codesLoaded,
      expression: "!codesLoaded"
    }],
    attrs: {
      "indeterminate": ""
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codesLoaded,
      expression: "codesLoaded"
    }]
  }, _vm._l(_vm.codes, function (code, codeIndex) {
    return _c('div', {
      key: code.id,
      staticClass: "code-line py-1 d-flex align-center",
      class: {
        'selected': _vm.selectedCodesIndexes.indexOf(codeIndex) >= 0
      }
    }, [_c('div', {
      staticClass: "d-flex flex-wrap align-center"
    }, [_c('div', {
      staticClass: "d-flex flex-no-wrap"
    }, [_c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "color": "#15bbf0",
        "value": _vm.selectedCodesIndexes.indexOf(codeIndex) >= 0
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSelectCode(codeIndex);
        }
      }
    }), _c('div', {
      staticClass: "mono word-break-all"
    }, [_c('span', [_vm._v(_vm._s(_vm.showUrl ? code.scm_data.scantrust_url_prefix ? code.scm_data.scantrust_url_prefix : _vm.singleNonSystemPrefix ? _vm.singleNonSystemPrefix : _vm.systemPrefix : '') + _vm._s(code.message) + " |")]), _c('span', {
      staticClass: "url product-name pl-2",
      on: {
        "click": function ($event) {
          return _vm.addProductFilter(code.product);
        }
      }
    }, [_vm._v(_vm._s(code.product.name))])])], 1), _vm._l(_vm.filterScmData(code.scm_data), function (value, name) {
      return _c('v-chip', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: value,
          expression: "value"
        }],
        key: `code-${code.id}-tags-${name}-${value}`,
        staticClass: "ml-2",
        attrs: {
          "color": "#f1f1f1",
          "text-color": "#0789b2"
        },
        on: {
          "click": function ($event) {
            return _vm.addFilter(name, value);
          }
        }
      }, [_vm._v(" " + _vm._s(name === 'scantrust_upload_batch' ? _vm.$t('upload_batch') : name.startsWith('gs1_') ? name.split('gs1_')[1] : name) + ": " + _vm._s(value) + " ")]);
    })], 2), _c('v-spacer'), _c('div', {
      staticClass: "d-flex flex-shrink-0 align-center"
    }, [_c('div', {
      staticClass: "date mono mr-2"
    }, [_vm._v(_vm._s(code.activated_at ? _vm.formatDate(code.activated_at) : _vm.formatDate(code.creation_date)))]), _c('code-tag-editor', {
      attrs: {
        "tags": _vm.scmFields,
        "codes": [code],
        "campaign": _vm.selectedCampaign.id
      }
    }), !_vm.isGS1Code(code.message) ? _c('code-change-product', {
      attrs: {
        "codes": [code]
      },
      on: {
        "code-transfered": _vm.loadCodes
      }
    }) : _vm._e(), _vm.isCodeSpacesEnabled ? _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "primary",
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.manageCodes(code.product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('qrcode_view_product')))])], 1), !_vm.isGS1Code(code.message) ? _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.handleDisplayUniqueIdEdit(code);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('qrcode_edit_unique_identifier')))])], 1) : _vm._e(), _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.handleDisplayGS1Edit(code);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.isGS1Code(code.message) ? _vm.$t('qrcode_edit_gs1_link') : _vm.$t('qrcode_convert_to_gs1_link')))])], 1)], 1)], 1) : _vm._e()], 1)], 1);
  }), 0), _vm.codesLoaded && !_vm.codes.length ? _c('div', {
    staticClass: "pa-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('codes_not_found')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "pagination-ctn mt-5 mb-4"
  }, [_c('v-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codesLoaded && _vm.codes.length,
      expression: "codesLoaded && codes.length"
    }],
    staticClass: "flex-grow-0",
    attrs: {
      "color": "primary",
      "total-visible": 7,
      "length": _vm.nbPages
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1), _c('v-overlay', {
    attrs: {
      "value": _vm.isLoadingProduct
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "48"
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "width": "600",
      "persistent": ""
    },
    model: {
      value: _vm.prefixDialog,
      callback: function ($$v) {
        _vm.prefixDialog = $$v;
      },
      expression: "prefixDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('select_url_prefix')))]), _c('v-card-text', {
    staticClass: "my-2 pb-0"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.formattedPrefixes,
      "label": _vm.$t('all_url_prefixes'),
      "item-text": "displayText",
      "item-value": "prefix",
      "persistent-hint": "",
      "hint": _vm.$t('prefix_will_be_associated_with_codes_selected')
    },
    on: {
      "change": function ($event) {
        _vm.showPrefixRequiredMessage = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "prefix"
        }, [_vm._v(_vm._s(item.displayText))])];
      }
    }]),
    model: {
      value: _vm.selectedPrefix,
      callback: function ($$v) {
        _vm.selectedPrefix = $$v;
      },
      expression: "selectedPrefix"
    }
  }), _vm.showPrefixRequiredMessage ? _c('span', {
    staticClass: "color-error mt-2 d-block"
  }, [_vm._v(_vm._s(_vm.$t('prefix_required')))]) : _vm._e()], 1), _c('v-card-actions', [_c('div', {
    staticClass: "mr-auto"
  }), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.downloadingCsv,
      "text": ""
    },
    on: {
      "click": _vm.closePrefixDialog
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "loading": _vm.downloadingCsv,
      "text": ""
    },
    on: {
      "click": _vm.confirmPrefixAndDownloadCsv
    }
  }, [_vm._v(_vm._s(_vm.$t('download_codes_csv')))])], 1)], 1)], 1), _vm.displayDialog && _vm.selectedCodeProduct ? _c('generate-qr-code-dialog', {
    attrs: {
      "display-dialog": _vm.displayDialog,
      "selected-product": _vm.selectedCodeProduct,
      "is-converting-to-gs1": _vm.isConvertingToGs1
    },
    on: {
      "update:displayDialog": function ($event) {
        _vm.displayDialog = $event;
      },
      "update:display-dialog": function ($event) {
        _vm.displayDialog = $event;
      }
    }
  }) : _vm._e(), _c('edit-confirmation-modal', {
    attrs: {
      "display-edit-modal": _vm.displayEditModal,
      "selected-code": _vm.code
    },
    on: {
      "update:displayEditModal": function ($event) {
        _vm.displayEditModal = $event;
      },
      "update:display-edit-modal": function ($event) {
        _vm.displayEditModal = $event;
      },
      "open-dialog": _vm.handleDisplayQrCodeDialog
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }